import React from "react";
import { goToCareersSite } from "../utils/careersSiteUrl";
import { useLanguage } from "../i18n/LanguageContext";
import heroBg from "../assests/revamp/hero-bg.png";

export default function Header() {
  const { t } = useLanguage();

  const handleEnquire = () => {
    const contactSection = document.getElementById("contact_us");
    if (contactSection) {
      const topOffset = contactSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };

  return (
    <header className="amgHero" id="home">
      <div className="amgHeroStage">
        <div className="amgHeroCopy">
          <p className="amgHeroLicense">{t("hero.eyebrow")}</p>
          <h1 className="amgHeroHead">{t("hero.headline")}</h1>
          <p className="amgHeroLead">{t("hero.lead")}</p>
          <div className="amgHeroActions">
            <button
              type="button"
              onClick={handleEnquire}
              className="amgHeroBtn amgHeroBtn--gold"
            >
              {t("hero.speak")}
            </button>
            <button
              type="button"
              onClick={goToCareersSite}
              className="amgHeroBtn amgHeroBtn--ghost"
            >
              {t("hero.explore")}
            </button>
          </div>
        </div>
        <figure className="amgHeroMedia">
          <img src={heroBg} alt="" />
        </figure>
      </div>
      <ul className="amgHeroProof" aria-label={t("hero.proofAria")}>
        <li>{t("hero.licensedUae")}</li>
        <li>{t("hero.licensedUs")}</li>
        <li>{t("hero.hqDubai")}</li>
      </ul>
    </header>
  );
}
